import _ from 'lodash';


export const getCountry = (userOrCountry) => {
    if (!userOrCountry) {
        return 'USA';
    }
    let country = _.isString(userOrCountry) ? userOrCountry : userOrCountry && userOrCountry['Country'];
    if (!country) {
        country = 'USA';
    }
    return country;
};


export const getCountryCode = (userOrCountry) => {
    let country = getCountry(userOrCountry);
    switch (country) {
        case 'USA':
            return 'US';
        case 'Canada':
            return 'CA';
        default:
            throw 'Unsupported country: ' + country;
    }
};


export const getCurrency = (userOrCountry) => {
    const country = getCountry(userOrCountry);
    if (country == 'Canada') {
        return 'CAD';
    } else {
        return 'USD';
    }
};


export const getStatesOptions = (userOrCountry) => {
    const country = getCountry(userOrCountry);
    if (country == 'Canada') {
        return provinces;
    } else {
        return states;
    }
};

export const getStatesLabel = (userOrCountry) => {
    const country = getCountry(userOrCountry);
    if (country== 'Canada') {
        return 'Province';
    } else {
        return 'State';
    }
};

export const getSupportedCountriesOptions = () => {
    return [
        {
            label: 'USA'
        },
        {
            label: 'Canada'
        }
    ]
};


export const getSupportedCountryCodesOptions = () => {
    return getSupportedCountriesOptions().map(c => ({label: getCountryCode(c.label)}));
};


export const normalizeZip = (value, previousValue, userOrCountry) => {
    if (!value) {
        return value;
    }

    const country = getCountry(userOrCountry);
    if (country == 'USA') {
        return value.replace(/[^\d-]/g, '');
    } else if (country == 'Canada') {
        return value.replace(/[^A-Za-z\d -]/g, '');
    }
    return value;
};


const provinces = [
    {
        label: 'AB'
    },
    {
        label: 'BC'
    },
    {
        label: 'MB'
    },
    {
        label: 'NB'
    },
    {
        label: 'NL'
    },
    {
        label: 'NT'
    },
    {
        label: 'NS'
    },
    {
        label: 'NU'
    },
    {
        label: 'ON'
    },
    {
        label: 'PE'
    },
    {
        label: 'QC'
    },
    {
        label: 'SK'
    },
    {
        label: 'YT'
    },
];


const states = [
    {
        label: "AL",
    },
    {
        label: "AK",
    },
    {
        label: "AS",
    },
    {
        label: "AZ",
    },
    {
        label: "AR",
    },
    {
        label: "CA",
    },
    {
        label: "CO",
    },
    {
        label: "CT",
    },
    {
        label: "DE",
    },
    {
        label: "DC",
    },
    {
        label: "FM",
    },
    {
        label: "FL",
    },
    {
        label: "GA",
    },
    {
        label: "GU",
    },
    {
        label: "HI",
    },
    {
        label: "ID",
    },
    {
        label: "IL",
    },
    {
        label: "IN",
    },
    {
        label: "IA",
    },
    {
        label: "KS",
    },
    {
        label: "KY",
    },
    {
        label: "LA",
    },
    {
        label: "ME",
    },
    {
        label: "MH",
    },
    {
        label: "MD",
    },
    {
        label: "MA",
    },
    {
        label: "MI",
    },
    {
        label: "MN",
    },
    {
        label: "MS",
    },
    {
        label: "MO",
    },
    {
        label: "MT",
    },
    {
        label: "NE",
    },
    {
        label: "NV",
    },
    {
        label: "NH",
    },
    {
        label: "NJ",
    },
    {
        label: "NM",
    },
    {
        label: "NY",
    },
    {
        label: "NC",
    },
    {
        label: "ND",
    },
    {
        label: "MP",
    },
    {
        label: "OH",
    },
    {
        label: "OK",
    },
    {
        label: "OR",
    },
    {
        label: "PW",
    },
    {
        label: "PA",
    },
    {
        label: "PR",
    },
    {
        label: "RI",
    },
    {
        label: "SC",
    },
    {
        label: "SD",
    },
    {
        label: "TN",
    },
    {
        label: "TX",
    },
    {
        label: "UT",
    },
    {
        label: "VT",
    },
    {
        label: "VI",
    },
    {
        label: "VA",
    },
    {
        label: "WA",
    },
    {
        label: "WV",
    },
    {
        label: "WI",
    },
    {
        label: "WY",
    },
];